import * as service from './service'
export default {
  namespace: 'rechargePay',
  state: {
    payData: {}
  },
  effects: {
    * toPay ({ payload }, { call, put }) {
      const res = yield call(service.toPay, payload)
      yield put({
        type: 'save',
        payload: {
          payData: res.data.data && JSON.parse(res.data.data)
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
